import { dislociranaenotaService } from '../services/dislociranaenota.service';
import Vue from 'vue'

const state = {
    dislociranaenota: [],
    sezona:null,
    predelovalecid:null
};

const actions = {
    load({ dispatch,commit },{sezona,predelovalecid,makeEditable}) {
        dispatch('alert/clear', "",{ root: true });
        commit('setSezona', sezona)
        commit('setPredelovalecID', predelovalecid)
      return dislociranaenotaService.load(sezona,predelovalecid)
            .then(
                dislociranaenota => {
                  commit('load', dislociranaenota);
                  if(makeEditable)
                  commit('makeEditable') 
                  return dislociranaenota;                   
                } 
                
            );
    },
       loadPreteklaSezona({ dispatch,commit },{sezona,predelovalecid,makeEditable}) {
         dispatch('alert/clear', "",{ root: true });
        //commit('setSezona', sezona)
        //commit('setpredelovalecID', predelovalecid)
        return new Promise((resolve, reject) => {

        
       dislociranaenotaService.loadPreteklaSezona(sezona,predelovalecid)
            .then(
                dislociranaenota => {
                
                    dislociranaenota.forEach(e=>{
                        e.id=null;
                        commit("add",e);
                    });

                  if(makeEditable)
                  commit('makeEditable') 
                  resolve(dislociranaenota);                   
                },
                error =>{
                    console.log("Nalaganje ni uspelo");
                    dispatch('alert/error', error, { root: true });
                    reject(error);
                }
                
            );
        });
    },
    loadVse({ dispatch,commit },{sezona}) {
          dispatch('alert/clear', "",{ root: true });
        commit('load');
          commit('setSezona', sezona)
       return  dislociranaenotaService.loadAll(sezona)
            .then(
                dislociranaenota => commit('load', dislociranaenota)
                //,
                //error => commit('getLoggedInFailure', error)
            );
    },
    loadbymso({ dispatch,commit },{mso,subjid,sezona,predelovalecid}) {
        commit('load');
          dispatch('alert/clear', "",{ root: true });
          let dslist=this.state.dislociranaenota;
        return dislociranaenotaService.loadbymso(mso,subjid,sezona)
            .then(
                dislociranaenota => {
                   
                    if(!dislociranaenota){
                    dispatch('alert/error', "Dislocirana enota s to številko ni bila najdena!", { root: true });
                    dislociranaenota={}
                    }
                //    else if (!predelovalec.kmgmid)    
                  //       dispatch('alert/warning', "Ta predelovalec ni nosilec kmetijskega gospodarstva!", { root: true });
                    else{
                        if(dslist.dislociranaenota.find(i=>i.subjid==dislociranaenota.subjid))
                            dispatch('alert/error', "Ta enota je že na seznamu!", { root: true });
                        else {
                        dislociranaenota.inEdit=1;
                        //dislociranaenota.id=dislociranaenota.subjid;
                        dislociranaenota.predelovalecid=predelovalecid;
                    commit('add', dislociranaenota);
                        }
                    }
                }
                //,
                //error => commit('getLoggedInFailure', error)
            ),
                error => {
                    console.log("Nalaganje ni uspelo");
                    dispatch('alert/error', error, { root: true });
                   
            };
    },
     
    save({ dispatch, commit }) {
     

         console.log("Shranjujem!");
        let sezona=this.state.dislociranaenota.sezona;
        let predelovalecid=this.state.dislociranaenota.predelovalecid;
        console.log(this.state);
        dispatch('alert/clear', "",{ root: true });

        this.state.dislociranaenota.dislociranaenota.forEach(item=>{
            item.sezona=sezona;
            item.predelovalecid=predelovalecid;
            console.log(item);
            if(!item.subjid) {
                 item.saved=false;
                dispatch('alert/error', "Subjid ni pravilen ali manjka", { root: true });

            }
            else if(item.jeaktivna){
              dislociranaenotaService.save(item)
               .then(
                dislociranaenota => {
                      Vue.set(item,'saved',true);
                     Vue.set(item,'id',dislociranaenota.id);
                     Vue.set(item,'jeaktivna',1); 
                   // commit("update",item);
                    
                },
                error => {
                    console.log("Shranjevanje ni uspelo");
                     Vue.set(item,'saved',false);
                    //commit("update",item);
                    dispatch('alert/error', error, { root: true });
                }
            );
            }
            else
             dislociranaenotaService.remove(item).then(
                dislociranaenota => {
                     Vue.set(item,'saved',true);
                    //commit("update",item);
                    
                },
                error => {
                    console.log("Brisanje ni uspelo");
                     Vue.set(item,'saved',false);
                  //  commit("update",item);
                    dispatch('alert/error', error, { root: true });
                });
            //tukaj naredi ikono, da je shranjvanje uspešno na začetku ali nekje
            //uporabi info, če je prišlo kje do napake!

          });
       
        
    }
};

const mutations = {
  
    load(state, dislociranaenota) {
       if(dislociranaenota)
        state.dislociranaenota=dislociranaenota;//.map(k=>{
          //  k["veljavnostcertifikataod"]=kendo.parseDate(k["veljavnostcertifikataod"]) 
            //return k;
        //}
            //);   
    },
    add(state, item) {
        if(!item.id) {
            //do id
            var minid=state.dislociranaenota.reduce((prev, curr) => prev.id < curr.id ? prev : curr,{id:0}).id;
            if(minid>0)
                minid=0;
            minid--;
            item.id=minid;
        }
        state.dislociranaenota.push(item);
    },
    setSezona(state, item) {
        state.sezona=item;
    },
    makeEditable(state){
        for (var i=0;i<state.dislociranaenota.length;i++){
            //let dateStr=state.dislociranaenota[i].veljavnostcertifikataod;
            //if(dateStr)
                //state.dislociranaenota[i].veljavnostcertifikataod=new Date(dateStr);
            //else
                //state.dislociranaenota[i].veljavnostcertifikataod=new Date( );
            let updated = Object.assign({}, state.dislociranaenota[i], { inEdit: true });
            state.dislociranaenota.splice(i,1,updated);
        }
        

    },
    setPredelovalecID(state, item) {
        state.predelovalecid=item;
    },
  
    update(state, item) {
        //state.kultura = kultura;
        //state.kultura;
       
        let updated;
        let itemID = item.id
            let index = state.dislociranaenota.findIndex(p =>
                (JSON.stringify({ ...p }) === JSON.stringify(item) )
                 || itemID && p.id === itemID);
            if (index >= 0) {
                updated = Object.assign({}, item);
                state.dislociranaenota.splice(index,1,updated);
            } else {
                let id = 1;
                state.dislociranaenota.forEach(p => { id = Math.max(p.id + 1, id); });
                updated = Object.assign({}, item, { id: id });
                state.dislociranaenota.unshift(updated);
                index = 0;
            }



        //    return data[index];
        //state.kultura=data;

    },
    remove(state, item) {
        let itemID = item.id
            let index = state.dislociranaenota.findIndex(p =>
                (JSON.stringify({ ...p }) === JSON.stringify(item) )
                 || itemID && p.id === itemID);
                console.log("Brisem!");
                console.log(index);
                console.log(state.dislociranaenota);
                state.dislociranaenota.splice(index, 1);
        
        //    return data[index];
        //state.dislociranaenota=data;

    },
    replace(state, dislociranaenota) {
        state.dislociranaenota = dislociranaenota;
    }
   
};

export const dislociranaenota = {
    namespaced: true,
    state,
    actions,
    mutations
};
